// extracted by mini-css-extract-plugin
export default {"subjects__body":"subjecttemplate_subjects__body__rD95Z","subjects__body_head":"subjecttemplate_subjects__body_head__OvYHt"};